import {createFileRoute} from '@tanstack/react-router';
import {CreditAccountPaymentPage} from 'pages/accounts/credits/payment/CreditAccountPaymentPage';

export const Route = createFileRoute(
  '/_protected/credit-account-payment/create/$id',
)({
  component: CreditAccountPaymentPage,
  validateSearch: (search: {cardId?: string}) => {
    return {cardId: search.cardId as string | undefined};
  },
});
